var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../../libs/dragscroll');
var equipmentClassToDisplayName = require('../../libs/equipmentClassToDisplayName');
var loaders = require('../../layout/components/loaders');
var edit = require('../../layout/components/edit');
var modal = require('../../layout/components/modal');
var auth = require('../../auth/models/session');
var modelDetail = require('../../components/modelDetail');
var modelActions = require('./modelActions');
var paginationWithSearch = require('../../data/components/paginationWithSearch');
var rowActionDropdown = require('../../components/rowActionDropdown');
var networkTreeTransferModal = require('../treeTransferModal');
var tableColumns = require('./tableColumns');
var pageTitle = require('../../layout/pageTitle');
var requestState = require('../requestState');

var STATUSES = ['ok', 'unknown', 'warning', 'error'];
var fieldsToShow = ['name', 'index', 'unit', 'scale', 'writable', 'error', 'overrideActive', 'alarmStatus', 'alarmEnabled', 'alarmName'];
var page = {};

function actionDropdown(items) {
  return m(rowActionDropdown, {
    position: 'fixed',
    align: 'left',
    buttonStyle: {
      minWidth: '1.6rem',
      paddingTop: '0.05rem',
      paddingBottom: '0.12rem',
      paddingLeft: '0.18rem',
      paddingRight: '0.18rem',
      lineHeight: '1'
    },
    items: items
  });
}

function rowActions(ctrl, children) {
  return [
    {
      label: 'Edit ' + ctrl.form.name,
      icon: 'ion-ios-compose',
      onclick: function () { ctrl.form.editDialogue(children); }
    },
    {
      label: 'Delete ' + ctrl.form.name,
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { ctrl.form.deleteDialogue(children); }
    }
  ];
}

function renderNameCell(ctrl, children, url) {
  return m('div.flex.items-center.justify-between', [
    m(m.route.Link, { href: url }, children.name),
    m('div.ml3.flex-none', [
      actionDropdown(rowActions(ctrl, children))
    ])
  ]);
}

page.oninit = function (vnode) {
  var ctrl = this;
  ctrl.recordModel = vnode.attrs.recordModel;
  ctrl.form = vnode.attrs.form;
  ctrl.newNode = prop(false);
  requestState.initialize(ctrl);
  pageTitle.set(null, { fallback: ctrl.recordModel.name });

  ctrl.init = function () {
    return requestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        url: "/api/v1/" + ctrl.recordModel.url + '/' + m.route.param('id'),
        method: "GET"
      })
      .then(function (res) {
        ctrl.record = res;
        pageTitle.set(ctrl.record, { fallback: ctrl.recordModel.name });
        ctrl.sort();
        ctrl.newNode(true);
      });
    });
  };

  ctrl.sort = function () {
    ctrl.record.children.sort(sortByStatus);
  };

  modal.on('closed', ctrl.init);
  
  ctrl.init();
  ctrl.childrenToShow = [];
};

page.onremove = function () {
  modal.off('closed', this.init);
};

page.view = function () {
  var ctrl = this;
  var stateView = requestState.view(ctrl);
  if (stateView) return stateView;
  if(!ctrl.record) return
  var gateway = ctrl.record.breadcrumbs[0];
  var isLontalkNetwork = ctrl.record && ctrl.record['@class'] === 'LontalkNetwork';
  return m('div', [
    m("div.mh3.mb3.pb2.bb.bw1.b--mid-gray.near-white.flex.justify-between.items-center.display",  [
      m('div.pb2.f-subheadline.fw5', [
        m('div.dib-ns.mr2', [
          m(m.route.Link, {href: '/networks'}, 'Networks'),
          ' / '
        ]),
        ctrl.record.breadcrumbs.map(function (ancestor, idx) {
          if (ancestor['@id'] == ctrl.record['@id']) {
            return m('div.dib-ns.mr2', ctrl.record.name)
          } else {
            return m('div.dib-ns.mr2', [
              m(m.route.Link, {href: '/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
              ' / '
            ])
          }
        })
      ]),
      (function () {
        if(edit.vm.editing() && auth.user().isSuperuser == 1){
          return m(rowActionDropdown, {
            items: [
              {
                label: 'Edit ' + ctrl.recordModel.name,
                icon: 'ion-ios-compose',
                onclick: () => ctrl.recordModel.editDialogue(ctrl.record)
              },
              isLontalkNetwork ? {
                label: 'Export Lontalk Network',
                icon: 'ion-document-text',
                onclick: () => networkTreeTransferModal.openHostExportModal(gateway, [ctrl.record])
              } : null,
              {
                label: 'New ' + ctrl.form.name,
                icon: 'ion-plus',
                onclick: () => ctrl.form.editDialogue({parent: ctrl.record['@rid']})
              }
            ].filter(Boolean)
          })
        }
      })(),
    ]),
    modelDetail(ctrl, ctrl.recordModel),
    modelActions(ctrl, ctrl.recordModel),
    m('div.mh3.mv3.bw1.pv1.tc.f3.bb', equipmentClassToDisplayName(ctrl.form.name, true)),
    m('div.cf', browse(ctrl)),
  ])
};

function browse (ctrl) {
  var fieldsArray = [];
  for (const [key, propertyDef] of Object.entries(ctrl.form.fields)) {
    if (propertyDef.type) {
      fieldsArray.push(key);
    }
  }

  return m('div.mh3',[
    m(paginationWithSearch, {
      data: ctrl.record.children,
      newNode: ctrl.newNode,
      dataToShow: ctrl.childrenToShow,
      placeHolder: 'Search',
      itemsPerPage: 30,
      fieldsToSearch: ['name']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              tableColumns.colgroup(fieldsArray),
              m('thead', [
                m('tr', [ 
                  fieldsArray.map(field => {
                    return m('th.ph0.tl', field)
                  }),
		                ])
                
              ]),
              m('tbody', [
                ctrl.childrenToShow.map(children => {
                  if(!children['@rid']){
                    return m('tr', [
                      fieldsArray.map(field => {
                        return m('td.tl.nowrap',[
                          m('label',{style:{'visibility':'hidden'}}, 'No Data')  
                        ])
                      })
                    ])
                  }else{
                    let url = '/' + children['@id'].split('/').slice(3,5).join('/').toLowerCase();
                    return m('tr', [
                      fieldsArray.map(field => {
                        return m('td.tl.nowrap', field == 'name' ? renderNameCell(ctrl, children, url) : children[field])
	                      })
	                    ])
	                  }
                })
              ])
            ])
          ])
        ])
      ])
      
    ])
  ])
};

function sortByStatus (a,b) {
  if (STATUSES.indexOf(a.status) < STATUSES.indexOf(b.status)) {
    return 1;
  } else if (STATUSES.indexOf(a.status) > STATUSES.indexOf(b.status)) {
    return -1;
  } else {
    return 0;
  }
};

module.exports = page;
